import { useEffect, useId, useRef } from 'react';
import { useIsMobileViewport } from '../breakpoints';
import { useBackLayer } from './backLayerContext';

/**
 * Meldet eine flüchtige Fläche (Sheet, Dialog, Modus, Inline-Eingabe) beim Verwalter an,
 * solange sie offen ist: ein Zurück-Druck schließt dann sie, statt die Seite zu verlassen.
 * Am Desktop wirkungslos — dort ist Zurück = vorige Seite die richtige Erwartung.
 *
 * `onClose` muss die Fläche wirklich schließen (derselbe Weg wie ✕), nicht nur einen
 * Zustand melden. Ohne montierten Provider passiert nichts.
 */
export function useCloseOnBack(open, onClose, { enabled = true } = {}) {
  const isMobile = useIsMobileViewport();
  const manager = useBackLayer();
  const id = useId();
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open || !enabled || !isMobile || !manager) return undefined;
    manager.register(id, () => onCloseRef.current?.());
    return () => manager.unregister(id);
  }, [open, enabled, isMobile, manager, id]);
}
